import { render, staticRenderFns } from "./ListPatients.vue?vue&type=template&id=e1d42fda&scoped=true&"
import script from "./ListPatients.vue?vue&type=script&lang=js&"
export * from "./ListPatients.vue?vue&type=script&lang=js&"
import style0 from "./ListPatients.vue?vue&type=style&index=0&id=e1d42fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d42fda",
  null
  
)

export default component.exports